import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../../lib/api/client';
import toast from 'react-hot-toast';

interface CustomerCheckInRequest {
  bookingId: string;
}

/**
 * Customer self-service check-in mutation hook
 * Allows customers to check in to their confirmed bookings
 */
export function useCustomerCheckIn() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, CustomerCheckInRequest>({
    mutationFn: async ({ bookingId }) => {
      await apiClient.post(`/bookings/${bookingId}/check-in`, {});
    },
    onSuccess: () => {
      // Show success message
      toast.success('Checked in successfully! Enjoy your session.');

      // Invalidate customer bookings to refresh the list
      void queryClient.invalidateQueries({ queryKey: ['bookings', 'customer'] });

      // Invalidate invoices as well since check-in generates invoice
      void queryClient.invalidateQueries({ queryKey: ['invoices', 'customer'] });
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (error: any) => {
      // Show error message
      const errorMessage =
        error?.response?.data?.message || 'Failed to check in. Please try again.';
      toast.error(errorMessage);
    },
  });
}
